// extracted by mini-css-extract-plugin
export default {"textCenter":"tLehNT"};